var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "software-development",
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.157,
    height: 103.108,
    viewBox: "0 0 135.157 103.108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21913",
    "data-name": "Path 21913",
    d: "M110.126,4H29.031C14.126,4,2,15.56,2,29.777V81.331c0,14.217,12.126,25.777,27.031,25.777h81.094c14.905,0,27.031-11.56,27.031-25.777V29.777C137.157,15.56,125.031,4,110.126,4Zm13.516,77.331c0,7.1-6.062,12.889-13.516,12.889H29.031c-7.454,0-13.516-5.784-13.516-12.889V42.666H123.641ZM15.516,29.777c0-7.1,6.062-12.889,13.516-12.889h81.094c7.454,0,13.516,5.784,13.516,12.889Z",
    transform: "translate(-2 -4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21914",
    "data-name": "Path 21914",
    d: "M11.951,42.145l11.8,6.818a5.908,5.908,0,0,0,5.9,0l11.8-6.818a5.9,5.9,0,0,0,2.951-5.112V23.408A5.9,5.9,0,0,0,41.46,18.3l-11.8-6.818a5.929,5.929,0,0,0-5.9,0L11.951,18.3A5.9,5.9,0,0,0,9,23.408V37.033A5.9,5.9,0,0,0,11.951,42.145ZM20.8,26.814l5.9-3.406,5.9,3.406v6.812l-5.9,3.406-5.9-3.406Z",
    transform: "translate(40.873 34.988)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftware);
export default __webpack_public_path__ + "static/media/software.2f0c89ac351561c74014680823d8c744.svg";
export { ForwardRef as ReactComponent };